export default __webpack_public_path__ + "locales/sk/PortalUnavailable.json?hash=e7cccb38a2f90070de7108049ea9c822";